var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.27 14.786l-2.424-1.794c.758-.898 1.136-2.095 1.136-3.366 0-2.991-2.5-5.46-5.529-5.46C4.423 4.167 2 6.71 2 9.702c0 2.991 2.5 5.46 5.529 5.46 1.363 0 2.575-.45 3.56-1.272l2.575 1.87c.075.074.227.074.303.074.151 0 .378-.074.454-.224.152-.224.076-.598-.151-.823zM3.136 9.701c0-2.393 1.97-4.338 4.393-4.338 2.424 0 4.317 1.945 4.317 4.338s-1.97 4.263-4.317 4.263c-2.348 0-4.393-1.945-4.393-4.263z",
    fill: "#C4C4C4"
  })));
}
export default SvgSearch;